export const TEAM = [
  { name: "Sören Hein", focus: "ATHX · Krafttraining · Functional Fitness", role: "Inhaber & Trainer", img: "/img/team-soeren.webp", pt: true,
    specialties: ["ATHX", "Krafttraining", "Functional Fitness"],
    main: ["HYROX & ATHX", "Krafttraining"],
    courses: ["HYROX", "ATHX", "Hybrid", "Kraftpur"],
    quals: ["Fitnesstrainer A- & B-Lizenz", "Personal-Trainer-Lizenz", "Medical Fitnesscoach", "Kettlebell-Trainer", "Ernährungsberater A-, B- & C-Lizenz"] },
  { name: "Greta Mees", focus: "Olympisches Gewichtheben · Gymnastics · ATHX", role: "Trainerin & Personal Trainerin", img: "/img/team-greta.webp", pt: true,
    specialties: ["Olympisches Gewichtheben", "Gymnastics", "ATHX", "Functional Fitness"],
    main: ["Olympisches Gewichtheben", "Functional Fitness"],
    courses: ["Full Body 60", "Hybrid", "Kraftpur", "Engine", "ATHX", "Aktiv & Stabil"],
    quals: ["Bachelor im Bereich Sport, Gesundheit und Ernährung", "Fitnesstrainerin A- & B-Lizenz", "Personal-Trainer-Lizenz (Medical Fitness)"] },
  { name: "Keanu Hansen", focus: "Wirbelsäulenkräftigung · HYROX · Functional Fitness", role: "Trainer", img: "/img/team-keanu.webp", pt: true,
    specialties: ["Wirbelsäulenkräftigung", "HYROX", "Functional Fitness"],
    main: ["Rückengesundheit", "Functional Fitness"],
    courses: ["Full Body 30/60", "Hybrid", "Mobility", "Bodyweight", "ATHX"],
    quals: ["Bachelor of Arts Gesundheitsmanagement", "Lizenz Wirbelsäulengymnastik"] },
  { name: "Janice Sauerland", focus: "Functional Fitness · Krafttraining · Mobility", role: "Trainerin", img: "/img/team-janice.webp", pt: true,
    specialties: ["Functional Fitness", "Krafttraining", "Mobility"],
    main: ["Functional Fitness", "Mobility"],
    courses: ["Full Body 30/60", "HYROX", "Hybrid", "ATHX", "Mobility", "Aktiv & Stabil"],
    quals: ["Fitnesskauffrau", "Functional-Trainer-Lizenz", "Rehasport-Ausbildung (Rehasport Deutschland e. V.)"] },
  { name: "Lydia Sauerland", focus: "Yoga · Atemarbeit", role: "Trainerin & Yogalehrerin", img: "/img/team-lydia.webp",
    specialties: ["Yoga", "Atemarbeit"],
    main: ["Yoga", "Atemarbeit"],
    courses: ["Yoga"],
    quals: ["Yogalehrerin: 200h Vinyasa & 300h Advanced Teacher (Timo Wahl)", "Osteopathic Yoga Teacher (100h)", "Restorative Yoga (Katonah Yoga®-Stil) & Private Teacher (75h)", "Atemcoach (Buteyko-Methode) & Breathwork Coach"] },
  { name: "Joke Adelerhof", focus: "Bodyweight · Hybrid", role: "Trainerin", img: "/img/team-joke.webp",
    specialties: ["Bodyweight", "Hybrid"],
    main: ["Bodyweight", "Rückentraining"],
    courses: ["Bodyweight", "Rückenfit", "Body & Mind"],
    quals: ["Diplom-Sportlehrerin"] },
];

export const ABOUT_IMG = {
  idea: "/img/about-idea.webp",
  studio1: "/img/team-studio.webp",
  studio2: "/img/stories/about-studio2.webp",
};

export const VALUES = [
  { title: "Qualität", text: "Lieber weniger Angebote richtig gut als viel mittelmäßig. Durchdacht programmiert, professionell gecoacht." },
  { title: "Ehrlichkeit", text: "Keine Wunderprogramme, keine 30-Tage-Versprechen, kein Verkaufsdruck. Wir wollen langfristige Ergebnisse." },
  { title: "Entwicklung", text: "Training hat einen Zweck. Wir machen Fortschritt möglich – und wo sinnvoll, sichtbar und messbar." },
  { title: "Was wir nicht sind", text: "Kein anonymes Discount-Gym. Kein Bodybuilding-Gym. Kein Wellnessclub. Kein reines Gesundheitsstudio." },
];

export const OWNER_STORY = {
  eyebrow: "Warum es FlensFitness gibt",
  img: "/img/about-idea.webp",
  signature: "Sören Hein & das FlensFitness-Team",
  blocks: [
    { paragraphs: [
      "Dienstagabend, kurz nach sechs. Jemand steht zum ersten Mal in unserem Kursraum. Etwas unsicher, ein bisschen nervös. Neben ihm macht sich jemand warm, der in drei Wochen bei einem HYROX-Wettkampf startet.",
      "Eine Stunde später klatschen die beiden sich ab.",
      "Genau dafür habe ich FlensFitness übernommen.",
      "Ich wollte einen Ort, an dem man gesehen wird. An dem man dich beim Namen kennt und merkt, wenn du mal fehlst. Einen Ort, an dem es egal ist, wo du gerade stehst. Ob du seit Jahren trainierst oder heute zum ersten Mal.",
      "Du kommst rein und musst an nichts denken. Das Training ist geplant, dein Coach ist da, dein Platz ist frei. Für eine Stunde ist der Alltag draußen.",
      "Wir sitzen alle zu viel. Im Büro, im Auto, auf dem Sofa. Deshalb geht es bei uns nicht um Geräte, sondern um Bewegung. Um einen Körper, der im Alltag mitmacht. Treppen ohne Pause. Den Rücken, der nicht mehr zieht.",
    ] },
    { title: "Echte Menschen", paragraphs: [
      "Es wird immer mehr KI geben. Vielleicht irgendwann auch Roboter. Ich bin trotzdem fest überzeugt: Was wir brauchen, sind echte Menschen.",
      "Jemanden, der dich fragt, wie dein Tag war. Ein Gespräch vor dem Kurs, ein Lachen zwischen zwei Sätzen, einfach mal alles rauslassen. Sport ist bei uns nie nur Sport.",
      "Viele haben tausend Kontakte im Handy und merken trotzdem, dass sie oft allein sind. Bewegung mit anderen gibt da etwas zurück, das man nirgends sonst bekommt.",
      "Bei uns vergleicht sich niemand. Hier hilft man sich. Der Anfänger wird angefeuert, der Wettkämpfer auch.",
    ] },
    { title: "So viel, wie du willst", paragraphs: [
      "Du musst hier nichts. Wer nach dem Kurs direkt nach Hause fährt, gehört genauso dazu.",
      "Aber die Möglichkeiten sind da. Sonntags zusammen laufen gehen. Zum ersten Mal mit anderen bei einem Wettkampf starten. Eine Herausforderung finden, an die du dich allein nie getraut hättest. Das liebe ich an unserer Community.",
    ] },
    { title: "Was mich antreibt", paragraphs: [
      "Zu sehen, wie Menschen sich verändern. Wie aus Fremden eine Gruppe wird. Wie jemand, der am Anfang kaum einen Liegestütz geschafft hat, plötzlich stolz von seinem ersten Klimmzug erzählt.",
      "Und wenn jemand nach ein paar Wochen sagt: „Warum bin ich nicht viel früher gekommen?“",
      "Dann weiß ich, dass wir alles richtig machen.",
    ] },
    { title: "Ohne dieses Team ginge es nicht", paragraphs: [
      "FlensFitness ist nicht eine Person. Es sind Greta, Janice, Keanu und alle, die jeden Tag auf der Fläche stehen, Technik korrigieren, motivieren und zuhören.",
      "Sie sind der Grund, warum du dich hier gesehen fühlst. Ohne sie würde nichts davon funktionieren.",
      "Komm vorbei. Wir freuen uns auf dich.",
    ] },
  ],
};

export const STUDIO_FACTS = ["Offizieller HYROX Training Club seit 2019", "ATHX Games Gym Affiliate seit 2026", "Offizieller Trainingspartner der Berufsfeuerwehr Flensburg", "4,9 von 5 Sternen bei Google"];

export const trainerSlug = (name = "") => name.trim().split(" ")[0].toLowerCase().replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ä/g, "ae").replace(/[^a-z]/g, "");

export const findTrainer = (name = "", team = TEAM) => {
  const first = trainerSlug(name);
  return first ? team.find((t) => trainerSlug(t.name) === first) : null;
};
